import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;

	height: 100%;
	padding: 20px;
	align-items: center;
	width: 300px;
`;

export const CloseBackground = styled.div`
	background-color: ${tokens.color_primary};
	color: ${tokens.color_white};

	width: 30px;
	height: 30px;
	border-radius: 50%;

	position: absolute;
	right: -10px;
	top: -10px;

	display: flex;
	justify-content: center;
	align-items: center;

	cursor: pointer;

	&:hover {
		filter: brightness(0.85);
	}
`;

export const Icon = styled.img`
	height: 35px;

	@media (max-width: 1200px) {
		height: 29px;
	}

	@media (max-width: 992px) {
		height: 26px;
	}

	@media (max-width: 768px) {
		height: 23px;
	}

	@media (max-width: 600px) {
		height: 21px;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	font-style: normal;
	font-size: 16px;
	line-height: 22px;
	color: ${tokens.color_primary_lightest_title};

	padding-bottom: 20px;
`;

export const ContentButton = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-end;

	padding: 1vh 1vh 0 0;
	width: 100%;

	button:nth-child(1) {
		margin-right: 10px;
	}
`;

export const ContentTitle = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	font-weight: 600;
	font-size: 16px;
	line-height: 22px;
	color: ${tokens.color_primary_lightest_title};

	padding-bottom: 20px;
`;

export const ContainerSpinner = styled.div`
	padding-top: 50px;
`;
